import { render, staticRenderFns } from "./ModalOrderHistoryItem.vue?vue&type=template&id=e60c636e&scoped=true&"
import script from "./ModalOrderHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ModalOrderHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrderHistoryItem.vue?vue&type=style&index=0&id=e60c636e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c636e",
  null
  
)

export default component.exports